import { useTranslations } from 'next-intl';
import Image from 'next/image';
import startTaskImage from '@/public/assets/image/gamification/daily-streak/start-task@2x.webp';
import COVER_EMPTY from '@/public/assets/image/gamification/missions/missions-empty-cover@2x.webp';
import { cn } from '@/utils/cn';

export const StreakEmptyState = () => {
  const t = useTranslations('gamification.daily-streak');

  return (
    <div className={cn('xl:grid xl:grid-cols-3 flex lg:w-full gap-3 grow flex-1 max-lg:min-w-[stretch]')}>
      <div
        className="flex h-20 lg:h-22 w-full px-4 py-[0.688rem] rounded-2xl glass-stroke-border justify-start pr-[7.188rem] overflow-hidden items-start flex-col gap-1 relative before:z-3! mt-2.5 md:max-w-102.25 md:mb-4"
      >
        <div className="gm-mission-empty-gradient" />
        <div
          style={{
            backgroundImage: `url(${COVER_EMPTY.src})`,
          }}
          className="absolute inset-0 -z-1 bg-no-repeat bg-cover"
        />
        <p className="text-lg font-medium leading-5.5 text-gradient bg-promo-banner-title-gradient">
          {t('start-title')}
        </p>
        <p className="text-xs font-medium leading-4 text-primary-3">
          {t('start-description')}
        </p>

        <Image
          src={startTaskImage}
          alt="Streak empty image"
          width={98}
          height={80}
          className="w-24.5 max-lg:top-1 h-20 lg:h-22 object-cover z-2 absolute top-0 right-0"
        />
      </div>
    </div>
  );
};
